const registerAddress = ADDRESS => ({ ADDRESS });

module.exports = ({ AGENT_ADDRESS }) => ({
  ...registerAddress(AGENT_ADDRESS)
});
